// extracted by mini-css-extract-plugin
export default {"attach-file":"styles_attach-file__mIl6E","wrapper":"styles_wrapper__wUoZV","scroll":"styles_scroll__3zTw8","root":"styles_root__dPWNQ"};